import { render } from "./FiscalDataComponent.vue?vue&type=template&id=0e9a80ea"
import script from "./FiscalDataComponent.vue?vue&type=script&lang=js"
export * from "./FiscalDataComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__